<script lang="ts">
  import Board from "./Board.svelte";
  import FormInput from "./FormInput.svelte";
  // source url as input
  export let src;
  export let image: HTMLImageElement;
</script>

<article>
  <div class="coloring-book">
    {#if !image}
      <FormInput bind:image {src} />
    {:else}
      <Board {image} {src} />
    {/if}
  </div>
</article>

<style type="text/scss">
  @import "App";
</style>
